// TODO move to domain

import { EVehicleType, UUID, UUID_NULL } from '@okcargo-apps/shared-domain';

export interface IAccount {
  capabilities: ECapabilities[]; // NEW
  role: ERoles; // NEW
  lang: string;

  id: string; // really unnecessary, identified in backend by token
  firstName: string; // from /services/uaa/api/drivers/me-light (user object)
  lastName: string;
  email: string;
  username: string;
  privacyPolicyAccepted?: boolean;
  // activated?: boolean,
  company: ICompany; // from /services/uaa/api/carriers/mine (company object)
}
export interface ICompany {
  id?: UUID;
  name: string;
  taxNumber: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  stateProvince: string;
  country: string;
  phone: string;
  activated: boolean;
  isInternational: boolean;
  // isFreelance: boolean; // from root json (outside company object); not in use
  isMarketAllowed: boolean;
  costCenters?: ICostCenter[];
}

export interface ICostCenter {
  id: UUID;
  name: string;
  // the following, are these necessary?
  // companyId?: number;
  // streetAddress?: string;
  // postalCode?: string;
  // city?: string;
  // stateProvince?: string;
  // country?: string;
}

export function getEmptyIAccount(): IAccount {
  return {
    id: '',

    capabilities: [] as const, // NEW
    role: ERoles.DEFAULT, // NEW
    lang: 'es',

    firstName: '',
    lastName: '',
    email: '',
    username: '',
    company: {
      // id: undefined,
      name: '',
      taxNumber: '',
      streetAddress: '',
      postalCode: '',
      city: '',
      stateProvince: '',
      country: '',
      phone: '',
      activated: false,
      isInternational: false,
      // isFreelance: false,
      isMarketAllowed: true,
    },
  };
}

export interface IAccountPreferences {
  id: UUID;

  consentEmail: boolean;
  consentWhatsApp: boolean;
  consentPhone: boolean;
  contactEmail?: string;
  contactPhone?: string;
  contactWhatsApp?: string;
  // vehicleTypes?: EVehicleType[];
  routes?: IPreferenceRoutes[];
  emailPeriodicity?: EMailingPeriodicity;
  freightsPerWeek?: number;

  // freightsPerWeek: number;

  tractorNumber?: number;
  canvasNumber?: number;
  boxNumber?: number;
  frigoNumber?: number;
  megaNumber?: number;

  // TODO Keep only for compatibility with the old questionnaire. In the future, remove
  oldQuestionnaire?: IOldQuestionnaire;
}

export interface IPreferenceRoutes {
  id: UUID;
  vehicleType: EVehicleType;
  originCountryIsoCode: string;
  originStateCode?: string;
  destinationCountryIsoCode: string;
  destinationStateCode?: string;
  originStateName?: string;
  destinationStateName?: string;
}

export interface IRouteGroup {
  id: string;
  origin: string;
  vehicleType: EVehicleType;
  destinations: IPreferenceRoutes[];
}

// TODO Keep only for compatibility with the old questionnaire. In the future, remove
export interface IOldQuestionnaire {
  carrierOrAgency?: boolean;
  interestedOnSameLines?: boolean;
  firstContact?: string;
  futureContact?: string[];
  isUsefullAcceptFreightWithLink?: boolean;
  receiveAllFreights?: boolean;
  exclusiveCarrier?: boolean;
  numberOfVehicles?: number;
  vehicleTypes?: string[];
  whatsappCommunicationsPhone?: string;
  comments?: string;
}

export function getEmptyIAccountPreferences(): IAccountPreferences {
  return {
    id: UUID_NULL,
    consentEmail: false,
    consentWhatsApp: false,
    consentPhone: false,
  };
}

export interface ICredentials {
  username: string;
  password: string;
  rememberMe: boolean;
}

export enum ERoles {
  DEFAULT = 'DEFAULT',
  DRIVER = 'DRIVER',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  DRIVER_ADMINISTRATIVE = 'DRIVER_ADMINISTRATIVE',
}

export enum ECapabilities {
  AUTHENTICATED = 'AUTHENTICATED',
  INTERACT_WITH_STOPS = 'INTERACT_WITH_STOPS',
  ADMINISTRATIVE_DOCUMENTS = 'ADMINISTRATIVE_DOCUMENTS',
  VIEW_PRICES = 'VIEW_PRICES',
  VIEW_MARKET = 'VIEW_MARKET',
  VIEW_DRIVERS = 'VIEW_DRIVERS',
  UPLOAD_FREIGHTS = 'UPLOAD_FREIGHTS',
  CRUD_VEHICLES = 'CRUD_VEHICLES', //
  CRUD_USERS = 'CRUD_USERS', //
  VIEW_MILEAGES = 'VIEW_MILEAGES',
  ASSIGN_DRIVERS = 'ASSIGN_DRIVERS',
  SUSTAINABILITY = 'SUSTAINABILITY',
}

export enum EMailingPeriodicity {
  REALTIME = 'REALTIME',
  HALF_HOURLY = 'HALF_HOURLY',
  HOURLY = 'HOURLY',
  TWICE_A_DAY = 'TWICE_A_DAY',
  MID_WORKING_HOUR = 'MID_WORKING_HOUR',
  LAST_WORKING_HOUR = 'LAST_WORKING_HOUR',
  NEVER = 'NEVER',
}
